export default __webpack_public_path__ + "static/media/Wall_Door_Left_Orange.256.79ce045f.png";